var map = {
	"./calculator.svg": 301,
	"./excel.svg": 302,
	"./exception_frame.png": 303,
	"./exception_frame.svg": 304,
	"./no_calculator.svg": 305,
	"./no_disconnect.svg": 306,
	"./no_headphones.svg": 307,
	"./no_instant_messaging.svg": 308,
	"./no_internet_browsing.svg": 309,
	"./no_leaving_camera.svg": 310,
	"./no_local_browsing.svg": 311,
	"./no_materials.svg": 312,
	"./no_pause.svg": 313,
	"./no_people_in_room.svg": 314,
	"./no_phone.svg": 315,
	"./no_tv_radio.svg": 316,
	"./notes.svg": 317,
	"./pdf.svg": 318,
	"./people_with_interaction.svg": 319,
	"./people_without_interaction.svg": 320,
	"./powerpoint.svg": 321,
	"./rule_frame.png": 322,
	"./rule_frame.svg": 323,
	"./specific_websites.svg": 324,
	"./textbooks.svg": 325,
	"./word.svg": 326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 300;